export default theme => ({
  root: {
    flex: 1,
    height: 'auto',
    '& .react-grid-Main': {
      outline: 'none',
      borderTop: `1px solid ${theme.colors.grey[100]}`
    }
  }
});